import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminCoreRoutingModule } from './presentation/admin-core-routing.module';
import { AdminMainDashboardPage } from './presentation';
import { NgxGbUiKitModule } from '@geekbears/ngx-gb-ui-kit';
import { HeaderComponent } from './presentation/containers/header/header.component';
import { SharedModule } from '@modules/shared/shared.module';
import { UsersStoreModule } from '@modules/company-manager/users/application/store/users-store';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [AdminMainDashboardPage, HeaderComponent],
  imports: [
    CommonModule,
    AdminCoreRoutingModule,
    NgxGbUiKitModule,
    SharedModule,
    MatIconModule,
    UsersStoreModule,

  ],
})
export class AdminCoreModule {}
